/**
 * useQualifyingCriteria — fetch the live 4-criteria status for the current
 * user from /api/upgrade/qualifying-criteria.
 *
 * Only fires when ``enabled`` is true (default true). Consumers pass
 * ``enabled=false`` when they know the user is already premium and no fetch
 * is needed — this avoids a useless backend hit on every dashboard render.
 */
import { useEffect, useState, useCallback } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function useQualifyingCriteria(enabled = true) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!enabled) return;
    setLoading(true);
    setError(null);
    try {
      const r = await fetch(`${BACKEND_URL}/api/upgrade/qualifying-criteria`);
      if (!r.ok) throw new Error(`criteria_${r.status}`);
      setData(await r.json());
    } catch (e) {
      setError(e.message || 'fetch_failed');
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => { load(); }, [load]);

  return { data, loading, error, reload: load };
}
